import { type PropsWithChildren } from 'react';

import { XYChartAxesFormatterProvider } from './XYChartAxesFormatterProvider.js';
import { XYChartAxesTicksProvider } from './XYChartAxesTicksProvider.js';
import { XYChartOverlayPerformanceProvider } from './XYChartOverlayPerformanceProvider.js';
import { XYChartScalesProvider } from './XYChartScalesProvider.js';
import { XYChartVisibleAxesScalesProvider } from './XYChartVisibleAxesScalesProvider.js';

export const XYChartProviders = ({ children }: PropsWithChildren) => (
  <XYChartScalesProvider>
    <XYChartOverlayPerformanceProvider>
      <XYChartAxesFormatterProvider>
        <XYChartVisibleAxesScalesProvider>
          <XYChartAxesTicksProvider>{children}</XYChartAxesTicksProvider>
        </XYChartVisibleAxesScalesProvider>
      </XYChartAxesFormatterProvider>
    </XYChartOverlayPerformanceProvider>
  </XYChartScalesProvider>
);
